/*
 * ReferenceLink : https://github.com/iamhosseindhv/notistack/issues/30#issuecomment-542863653
 */

import { useSnackbar } from 'notistack';

let useSnackbarRef;

export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

const Notify = {
  success(msg) {
    this.toast(msg, 'success');
  },
  warning(msg) {
    this.toast(msg, 'warning');
  },
  info(msg) {
    this.toast(msg, 'info');
  },
  error(msg) {
  useSnackbarRef.enqueueSnackbar(msg, {
    variant: 'error',
    persist: false,
  });
},
  toast(msg, variant = 'default') {
    useSnackbarRef.enqueueSnackbar(msg, { variant }); 
  }
};

export default Notify;
